document.addEventListener('DOMContentLoaded', function () {
  initialiseBiggerPicture();
  initialiseProgressBar();
});

// Set up BiggerPicture lightbox functionality
function initialiseBiggerPicture() {
  // Check if BiggerPicture is available in global scope
  if (typeof window.BiggerPicture === 'undefined') return;

  const bp = window.BiggerPicture({
    target: document.body,
    keyboard: true,
    bodyScroll: false,
  });

  const gallery = document.querySelector(`#MediaGallery-${window.mediaGallerySection}`);
  if (!gallery) return;

  gallery.addEventListener('click', handleGalleryClick.bind(null, bp, gallery));
}

// Handle clicks on gallery items to open lightbox
function handleGalleryClick(bp, gallery, event) {
  const imageLink = event.target.closest('a[data-img]');
  const videoButton = event.target.closest('.deferred-media__poster');

  if (!imageLink && !videoButton) return;

  event.preventDefault();
  event.stopPropagation();

  const items = [];
  const mediaElements = gallery.querySelectorAll('.product__media-item');

  mediaElements.forEach((mediaItem) => {
    if (mediaItem.querySelector('deferred-media')) {
      const deferredMedia = mediaItem.querySelector('deferred-media');
      const template = deferredMedia.querySelector('template');
      const posterImage = deferredMedia.querySelector('.deferred-media__poster img');

      if (template && posterImage) {
        const videoElement = template.content.querySelector('iframe, video');
        if (videoElement) {
          items.push({
            type: 'html',
            html: `<div class="bp-video-container">${videoElement.outerHTML}</div>`,
            thumb: posterImage.src,
          });
        }
      }
    } else {
      const link = mediaItem.querySelector('a[data-img]');
      if (link) {
        items.push({
          type: 'image',
          img: link.getAttribute('data-img'),
          thumb: link.getAttribute('data-thumb'),
          alt: link.getAttribute('data-alt'),
          width: link.getAttribute('data-width'),
          height: link.getAttribute('data-height'),
        });
      }
    }
  });

  // Create thumbnail navigation
  const currentIndex = getCurrentIndex(imageLink || videoButton, gallery);
  const thumbsContainer = document.createElement('div');
  thumbsContainer.className = 'bp-thumbs';

  const splideContainer = document.createElement('div');
  splideContainer.className = 'splide thumbnail-splide';

  const splideTrack = document.createElement('div');
  splideTrack.className = 'splide__track';

  const splideList = document.createElement('ul');
  splideList.className = 'splide__list';

  // Build thumbnail list
  items.forEach((item) => {
    const splideSlide = document.createElement('li');
    splideSlide.className = 'splide__slide';

    const thumb = document.createElement('div');
    thumb.className = 'bp-thumb-wrapper';

    const thumbImg = new Image();
    thumbImg.src = item.thumb;
    thumbImg.className = 'bp-thumb';
    thumb.appendChild(thumbImg);

    // Add play icon for video thumbnails
    if (item.type === 'html') {
      const playIcon = document.createElement('span');
      playIcon.className = 'bp-thumb-play-icon';
      playIcon.innerHTML = `
        <span class="svg-wrapper">
          <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
            <path fill="currentColor" d="M20.5 11.25l-14.5 8.25v-16.5l14.5 8.25z"/>
          </svg>
        </span>
      `;
      thumb.appendChild(playIcon);
    }

    splideSlide.appendChild(thumb);
    splideList.appendChild(splideSlide);
  });

  splideTrack.appendChild(splideList);
  splideContainer.appendChild(splideTrack);
  thumbsContainer.appendChild(splideContainer);

  // Store items globally for access in update handler
  window.bpGalleryItems = items;

  // Open BiggerPicture lightbox
  bp.open({
    items,
    intro: true,
    position: currentIndex,
    scale: 0.85,
    onOpen: () => {
      if (!window.Splide) return;

      // Initialize thumbnail slider
      const bpContainer = document.querySelector('.bp-wrap');
      bpContainer.appendChild(thumbsContainer);

      const splide = new window.Splide('.thumbnail-splide', {
        rewind: true,
        fixedWidth: 100,
        fixedHeight: 100,
        isNavigation: false,
        gap: 8,
        pagination: false,
        cover: true,
        dragMinThreshold: {
          mouse: 4,
          touch: 10,
        },
      });

      // Sync thumbnail slider with main image
      splide.on('moved', (newIndex) => {
        if (!splide.bpTriggered) {
          bp.setPosition(newIndex);
        }
        splide.bpTriggered = false;
      });

      splide.mount();
      window.currentSplide = splide;

      // Add click handlers to thumbnails
      const thumbWrappers = document.querySelectorAll('.bp-thumb-wrapper');
      const thumbClickHandlers = new Map();

      thumbWrappers.forEach((wrapper, index) => {
        const handler = () => {
          bp.setPosition(index);
        };
        thumbClickHandlers.set(wrapper, handler);
        wrapper.addEventListener('click', handler);
      });

      // Store handlers for cleanup
      window.bpThumbHandlers = thumbClickHandlers;

      updateThumbnailState(currentIndex, thumbWrappers, splide);
    },
    onClose: () => {
      if (!window.bpThumbHandlers) return;

      window.bpThumbHandlers.forEach((handler, wrapper) => {
        wrapper.removeEventListener('click', handler);
      });
      window.bpThumbHandlers = null;
    },
    onUpdate: handleLightboxUpdate,
  });
}

// Update thumbnail states when lightbox image changes
function handleLightboxUpdate(container, activeItem) {
  const thumbs = document.querySelectorAll('.bp-thumb-wrapper');
  const splide = window.currentSplide;

  if (!splide || !thumbs.length) return;

  const currentIndex = window.bpGalleryItems.indexOf(activeItem);

  // Update visual states
  updateThumbnailState(currentIndex, thumbs, splide);

  // Sync slider position
  if (!splide.bpTriggered) {
    splide.go(currentIndex);
  }
  splide.bpTriggered = false;
}

// Update active states of thumbnails
function updateThumbnailState(index, thumbs, splide) {
  // Update thumbnail wrapper states
  thumbs.forEach((thumb, i) => {
    thumb.classList.toggle('active', i === index);
  });

  // Update Splide slider states
  if (splide) {
    splide.Components.Elements.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    splide.refresh();
  }
}

// Get index of clicked gallery item
function getCurrentIndex(target, gallery) {
  const mediaElements = gallery.querySelectorAll('.product__media-item');
  const index = Array.from(mediaElements).indexOf(target.closest('.product__media-item'));
  return index;
}

// Initialise progress bar functionality
function initialiseProgressBar() {
  const sliderList = document.querySelector(`#Slider-Gallery-${window.mediaGallerySection}`);
  const progressBar = document.querySelector('.slider-progress-bar');

  if (!sliderList || !progressBar) return;

  // Calculate total slides
  const slides = sliderList.querySelectorAll('.slider__slide');
  const totalSlides = slides.length;

  // Update progress bar on scroll
  sliderList.addEventListener('scroll', () => {
    const maxScroll = sliderList.scrollWidth - sliderList.clientWidth;
    const currentScroll = sliderList.scrollLeft;

    // Calculate progress percentage
    const slideProgress = (currentScroll / maxScroll) * (totalSlides - 1);
    const progressPercentage = ((slideProgress + 1) / totalSlides) * 100;

    progressBar.style.width = `${progressPercentage}%`;
  });

  // Handle progress bar interaction
  const progressContainer = document.querySelector('.slider-progress');
  let isDragging = false;

  const updateScrollPosition = (clientX) => {
    const rect = progressContainer.getBoundingClientRect();
    const clickPercentage = (clientX - rect.left) / rect.width;
    const maxScroll = sliderList.scrollWidth - sliderList.clientWidth;

    // Convert click position to scroll position
    const adjustedPercentage = Math.max(0, Math.min(1, (clickPercentage * totalSlides - 1) / (totalSlides - 1)));
    sliderList.scrollLeft = adjustedPercentage * maxScroll;
  };

  // Mouse events
  progressContainer.addEventListener('mousedown', (event) => {
    isDragging = true;
    progressContainer.style.cursor = 'grabbing';
    updateScrollPosition(event.clientX);
  });

  document.addEventListener('mousemove', (event) => {
    if (!isDragging) return;
    updateScrollPosition(event.clientX);
  });

  document.addEventListener('mouseup', () => {
    isDragging = false;
    progressContainer.style.cursor = 'pointer';
  });

  // Touch events
  progressContainer.addEventListener('touchstart', (event) => {
    isDragging = true;
    // Prevent page scroll
    event.preventDefault();
    updateScrollPosition(event.touches[0].clientX);
  });

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!isDragging) return;
      // Prevent page scroll
      event.preventDefault();
      updateScrollPosition(event.touches[0].clientX);
    },
    { passive: false }
  );

  document.addEventListener('touchend', () => {
    isDragging = false;
  });

  // Set initial progress
  progressBar.style.width = `${(1 / totalSlides) * 100}%`;
}
